import {
	baseUrl
} from './env'
import { getStore, getUrlRelativePath, clearUserInStore, getTimezoneName} from "./mUtils";
import global_ from "@/core/global";

export default async (url = '', data = {}, type = 'GET', method = 'fetch', token = '', isFile = false) => {
	if (url != "/User/Login" && url != "/User/ValidateToken" && url !="/FileStorage/GetBlobStorageConfig"){
		global_.hubHandler.checkConnectionStatus();
	}
	//var baseUrl = process.env.API_ROOT
	type = type.toUpperCase();
	url = baseUrl + url;
	let timezone = getTimezoneName();
	let securityKey = getStore('securityKey');
	if (type == 'GET') {
		let dataStr = ''; //数据拼接字符串
		Object.keys(data).forEach(key => {
			dataStr += key + '=' + data[key] + '&';
		})

		if (dataStr !== '') {
			dataStr = dataStr.substr(0, dataStr.lastIndexOf('&'));
			url = url + '?' + dataStr;
		}
	}

	if (window.fetch && method == 'fetch') {
		let requestConfig = {
			//credentials: 'include',
			method: type,
			headers: {
				//'Accept': 'application/json',
				'Content-Type': 'application/json',
				// "Access-Control-Allow-Origin": "*",
				// "Access-Control-Allow-Headers": "*",
				"pragma":"no-cache",
				"cache-control":"no-cache",
				"timezone":timezone,
				'securityKey':securityKey
			},
			mode: "cors",
			//cache: "force-cache"
		}
		if (!!token) {
			requestConfig.headers['Authorization'] = 'Bearer ' + token;
		}
		if (type == 'POST') {
			Object.defineProperty(requestConfig, 'body', {
				value: JSON.stringify(data)
			})
		}

		try {
			return await fetch(url, requestConfig).then((response) => {

				if (response.status == 200) {
					if (isFile){
						let filename = (response.headers['Content-Disposition'] || '').split('filename=')[1];
						return response.blob().then((responseJson) => {
							return { success: true, data: responseJson, filename:filename };
						});
					}else{
						return response.json().then((responseJson) => {
							return { success: true, data: responseJson };
						});
					}
				} else if (response.status == 400) {
					//let msg = responseJson.message;
					//return { success: false, message: msg };
					return response.json().then((responseJson) => {
						let msg = '';
						if (!!responseJson) {
							msg = responseJson.Message;
						}

						return { success: false, message: msg };
					});
				} else if (response.status == 401) {
					let role = getStore('user_role');
					let path = getUrlRelativePath(window.location.href);
					//console.log(path);
					if (path != '/#/') {
						clearUserInStore();
						if (role == '1') {
							window.location.href = "/#/";
							//window.location.reload();
						} else {

							window.location.href = "/";
						}
					}
				} else if (response.status == 403) {
					return { success: false, message: '您无权进行此操作' };
				} else {
					return { success: false, message: '' };
				}
			})
				.catch((err) => {
					throw new Error(err)
				});
			//const response = await fetch(url, requestConfig);
			//const responseJson = await response.json();

		} catch (error) {
			//console.log(error);
			throw new Error(error)
		}
	} else {
		return new Promise((resolve, reject) => {
			let requestObj;
			if (window.XMLHttpRequest) {
				requestObj = new XMLHttpRequest();
			} else {
				requestObj = new ActiveXObject;
			}

			let sendData = '';
			if (type == 'POST') {
				sendData = JSON.stringify(data);
			}

			requestObj.open(type, url, true);
			requestObj.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
			requestObj.setRequestHeader("timezone", timezone);
			requestObj.setRequestHeader("securityKey", securityKey);
			if (!!token) {
				requestObj.setRequestHeader('Authorization', 'Bearer ' + token);
			}
			requestObj.send(sendData);

			requestObj.onreadystatechange = () => {
				//debugger;
				if (requestObj.readyState == 4) {
					if (requestObj.status == 200) {
						let obj = requestObj.response
						if (typeof obj !== 'object') {
							obj = JSON.parse(obj);
						}
						resolve(obj)
					} else {
						reject(requestObj)
					}
				}
			}
		})
	}
}


// WEBPACK FOOTER //
// ./src/config/fetch.js